import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { createQueryClient } from "./lib/query-client";
// №29.1 — tokens load EAGERLY, before the legacy sheet.
//
// `tokens.css` used to be imported only from the route components (`V3Layout`,
// `AppShellLayout`), so it arrived in a lazy chunk. Anything painted before that
// chunk resolved — including `body` — had no `--color-background-*` to read, which
// is half of why the boot ground was a hardcoded colour in `index.css` instead of a
// token. Importing it here puts the token layer in the entry CSS, so the very first
// painted frame can be the right one. Order matters: tokens FIRST, so `index.css`
// (the legacy console sheet) still wins where it deliberately overrides.
// №29.1 (③) — Inter + Tabler, self-hosted. Was three render-blocking third-party
// stylesheets in index.html; see the header of fonts.css for why Material Symbols
// is not among them.
import "./v3/styles/fonts.css";
import "./v3/styles/tokens.css";
import "./index.css";

const queryClient = createQueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
